import React from 'react'

function Footer() {
  return (
<>{/* Footer */}
<footer className="footer">
  <div className="row">
    <div className="col d-flex">
      <h4>INFORMATION</h4>
      <a href>About us</a>
      <a href>Contact Us</a>
      <a href>Term &amp; Conditions</a>
      <a href>Shipping Guide</a>
    </div>
    <div className="col d-flex">
      <h4>USEFUL LINK</h4>
      <a href>Online Store</a>
      <a href>Customer Services</a>
      <a href>Promotion</a>
      <a href>Top Brands</a>
    </div>
    <div className="col d-flex">
      <span><i className="bx bxl-facebook-square" /></span>
      <span><i className="bx bxl-instagram-alt" /></span>
      <span><i className="bx bxl-github" /></span>
      <span><i className="bx bxl-twitter" /></span>
      <span><i className="bx bxl-pinterest" /></span>
    </div>
  </div>
  <span/>
  <br/>
<div className='footer1'>                  <p>Copyright © 2024 Design By <span className="deve">DeveloperGTM</span></p>
</div>
</footer>

</>    
)
}

export default Footer
